import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { rootRouteRef, dashboardRouteRef } from './routes';

export const activityLogPlugin = createPlugin({
  id: 'activity-log',
  routes: {
    root: rootRouteRef,
    dashboard: dashboardRouteRef,
  },
});

export const ActivityLogPage = activityLogPlugin.provide(
  createRoutableExtension({
    name: 'ActivityLogPage',
    component: () =>
      import('./components/ActivityLogPage').then(m => m.ActivityLogPage),
    mountPoint: rootRouteRef,
  }),
);

export const ActivityLogDashboardPage = activityLogPlugin.provide(
  createRoutableExtension({
    name: 'ActivityLogDashboardPage',
    component: () =>
      import('./components/ActivityLogDashboard').then(
        m => m.ActivityLogDashboard,
      ),
    mountPoint: dashboardRouteRef,
  }),
);
